import React, { useState } from "react";
import SectionTitle from "./SectionTitle.jsx";
import TeamLead from "./TeamLead.jsx";
import QA from "./QA.jsx";
import Internship from "./Internship.jsx";
import StartUp from "./StartUp.jsx";
import Packt from "./Packt.jsx";
import AMD from "./Amd.jsx";
import IITM from "./Iitm.jsx";

const Experience = () => {
  const [workTeamLead, setWorkTeamLead] = useState(false);
  const [workQA, setWorkQA] = useState(false);
  const [workInternship, setWorkInternship] = useState(false);
  const [workStartUp, setWorkStartUp] = useState(false);
  const [packtpublishing, setPacktPublshing] = useState(false);
  const [workAMD, setWorkAMD] = useState(true);
  const [workIITM, setWorkIITM] = useState(false);

  const handleTeamLead = () => {
    setWorkTeamLead(true);
    setWorkQA(false);
    setWorkInternship(false);
    setWorkStartUp(false);
    setPacktPublshing(false);
    setWorkAMD(false);
    setWorkIITM(false);
  };

  const handleAMD = () => {
    setWorkTeamLead(false);
    setWorkQA(false);
    setWorkInternship(false);
    setWorkStartUp(false);
    setPacktPublshing(false);
    setWorkAMD(true);
    setWorkIITM(false);
  };

  const handleIITM = () => {
    setWorkTeamLead(false);
    setWorkQA(false);
    setWorkInternship(false);
    setWorkStartUp(false);
    setPacktPublshing(false);
    setWorkAMD(false);
    setWorkIITM(true);
  };

  const handleQA = () => {
    setWorkTeamLead(false);
    setWorkQA(true);
    setWorkInternship(false);
    setWorkStartUp(false);
    setPacktPublshing(false);
    setWorkAMD(false);
    setWorkIITM(false);
  };

  const handleInternship = () => {
    setWorkTeamLead(false);
    setWorkQA(false);
    setPacktPublshing(false);
    setWorkStartUp(false);
    setWorkInternship(true);
    setPacktPublshing(false);
    setWorkAMD(false);
    setWorkIITM(false);
  };

  const handleStartUp = () => {
    setWorkTeamLead(false);
    setWorkQA(false);
    setWorkInternship(false);
    setWorkStartUp(true);
    setPacktPublshing(false);
    setWorkAMD(false);
    setWorkIITM(false);
  };

  const handlePacktPublishing = () => {
    setWorkTeamLead(false);
    setWorkQA(false);
    setWorkInternship(false);
    setWorkStartUp(false);
    setPacktPublshing(true);
    setWorkAMD(false);
    setWorkIITM(false);
  };

  return (
    <section
      id="Experience"
      className="max-w-[1024px] min-h-screen mx-auto py-10 lg:py-20 flex flex-col gap-5 justify-center"
    >
      <SectionTitle titleName="Where I have worked" titleNumber="03" />
      {/* CONTAINER DIV */}
      <div className="w-full h-fit mt-5 flex flex-col lg:flex-row gap-4 ">
        {/*  SIDE BAR */}
        <div className="flex w-full lg:w-[fit-content] h-[fit-content]">
          <ul className="flex lg:flex-col overflow-x-scroll no-scrollbar">
            {/* Fellowship.ai */}
            <li
              onClick={handleAMD}
              className={`${
                workAMD
                  ? "border-l-textGreen text-textGreen"
                  : "border-l-hoverColor : text-textDark"
              } border-l-2 border-l-textGreen text-textDark bg-transparent hover:bg-[#112240] py-3 text-xs cursor-pointer duration-300 px-8 font-medium md:text-sm `}
            >
              <span
                className={`${
                  workAMD ? "text-textGreen" : "text-textDark"
                }`}
              >
                AMD
              </span>
              <br />
            </li>
            <li
              onClick={handleIITM}
              className={`${
                workIITM
                  ? "border-l-textGreen text-textGreen"
                  : "border-l-hoverColor : text-textDark"
              } border-l-2 border-l-textGreen text-textDark bg-transparent hover:bg-[#112240] py-3 text-xs cursor-pointer duration-300 px-8 font-medium md:text-sm `}
            >
              <span
                className={`${
                  workIITM ? "text-textGreen" : "text-textDark"
                }`}
              >
                IIT Madras
              </span>
              <br />
            </li>
            <li
              onClick={handleStartUp}
              className={`${
                workStartUp
                  ? "border-l-textGreen text-textGreen"
                  : "border-l-hoverColor : text-textDark"
              } border-l-2 border-l-textGreen text-textDark bg-transparent hover:bg-[#112240] py-3 text-xs cursor-pointer duration-300 px-8 font-medium md:text-sm `}
            >
              <span
                className={`${
                  workStartUp ? "text-textGreen" : "text-textDark"
                }`}
              >
                Fellowship.ai
              </span>
              <br />
            </li>

            {/* TeamLead */}
            <li
              onClick={handlePacktPublishing}
              className={`${
                packtpublishing
                  ? "border-l-textGreen text-textGreen"
                  : "border-l-hoverColor : text-textDark"
              } border-l-2 border-l-textGreen text-textDark bg-transparent hover:bg-[#112240] py-3 text-xs cursor-pointer duration-300 px-8 font-medium md:text-sm `}
            >
              <span
                className={`${
                  packtpublishing ? "text-textGreen" : "text-textDark"
                }`}
              >
                Packt Publishing
              </span>
              <br />
            </li>

            <li
              onClick={handleTeamLead}
              className={`${
                workTeamLead
                  ? "border-l-textGreen text-textGreen"
                  : "border-l-hoverColor : text-textDark"
              } border-l-2 border-l-textGreen text-textDark bg-transparent hover:bg-[#112240] py-3 text-xs cursor-pointer duration-300 px-8 font-medium md:text-sm `}
            >
              <span
                className={`${
                  workTeamLead ? "text-textGreen" : "text-textDark"
                }`}
              >
                C4GT'23
              </span>
              <br />
            </li>

            {/* QA */}
            <li
              onClick={handleQA}
              className={`${
                workQA
                  ? "border-l-textGreen text-textGreen"
                  : "border-l-hoverColor : text-textDark"
              } border-l-2 border-l-textGreen text-textDark bg-transparent hover:bg-[#112240] py-3 text-xs cursor-pointer duration-300 px-8 font-medium md:text-sm `}
            >
              <span
                className={`${workQA ? "text-textGreen" : "text-textDark"}`}
              >
                Digilocker
              </span>
            </li>

            {/* Internship */}
            <li
              onClick={handleInternship}
              className={`${
                workInternship
                  ? "border-l-textGreen text-textGreen"
                  : "border-l-hoverColor : text-textDark"
              } border-l-2 border-l-textGreen text-textDark bg-transparent hover:bg-[#112240] py-3 text-xs cursor-pointer duration-300 px-8 font-medium md:text-sm `}
            >
              <span
                className={`${
                  workInternship ? "text-textGreen" : "text-textDark"
                }`}
              >
                Parentheses Labs
              </span>
              <br />
            </li>
          </ul>
        </div>

        {/* Work information */}
        {workTeamLead && <TeamLead />}
        {workQA && <QA />}
        {workInternship && <Internship />}
        {workStartUp && <StartUp />}
        {workAMD && <AMD />}
        {workIITM && <IITM />}
        {packtpublishing && <Packt />}
      </div>
    </section>
  );
};

export default Experience;
